export const setupTOTP = {
    QR: {
        totpIssuer: 'Webgains',
    },
}

export default setupTOTP
